import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { marketingService } from '../api/services/marketingService';
import { storeCampaign } from '../utils/marketing';
import NotFound from '../notfound';
import './DownloadPage.css';

/**
 * Handles influencer short links such as autoplace.al/abc.
 * Resolves the slug via the backend, tags the visitor with the campaign, then
 * hands off to the /download page. Unknown/inactive slugs fall through to 404.
 *
 * Mounted on the single-segment `/:slug` route, which React Router ranks below
 * every static route, so it only catches otherwise-unmatched top-level paths.
 */
const ShortLinkRedirect: React.FC = () => {
  const { slug = '' } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const result = await marketingService.resolveSlug(slug);
        if (!active) return;
        if (result?.active) {
          storeCampaign(result.slug);
          const params = new URLSearchParams({ campaign: result.slug });
          const lang = searchParams.get('lang'); // carry language through
          if (lang) params.set('lang', lang);
          navigate(`/download?${params.toString()}`, { replace: true });
        } else {
          setNotFound(true);
        }
      } catch {
        if (active) setNotFound(true);
      }
    })();
    return () => {
      active = false;
    };
  }, [slug, navigate, searchParams]);

  if (notFound) return <NotFound />;

  return (
    <div className="download-page">
      <div className="download-redirecting">
        <div className="ap-spinner" aria-hidden />
      </div>
    </div>
  );
};

export default ShortLinkRedirect;
